export class LeadTimeUtils {

  static readonly PARTS = 'PTS';
  static readonly QUICK_SHIP_CODES: string[] = ['SST', 'SS5'];
  static readonly QUICK_SHIP_FPA_MESSAGE: string = 'FPA is not allowed on quotes or orders with a Quick Ship Lead Time selected.  Please change the lead time to Standard before requesting a FPA';

  static isPartsOrder(leadTimeCode: string | undefined): boolean {
    return LeadTimeUtils.PARTS === (leadTimeCode || '');
  }

  static isQuickShip(leadTimeCode: string | undefined): boolean {
    return LeadTimeUtils.QUICK_SHIP_CODES.includes(leadTimeCode ?? '');
  }

  static isPaperPilotLeadTime(leadTimeCode: string | undefined): boolean {
    return LeadTimeUtils.PAPER_PILOT_CODES.includes(leadTimeCode ?? '');
  }

  static readonly PAPER_PILOT = 'PPT';
  static readonly KANBAN_PAPER_PILOT = 'KBN';
  static readonly PAPER_PILOT_CODES: string[] = [LeadTimeUtils.PAPER_PILOT, LeadTimeUtils.KANBAN_PAPER_PILOT];

}
